import { useQuery } from '@tanstack/react-query'
import { origin_point_engine_api } from '@/lib/axios-client'

interface UnreadCountResponse {
  code: number
  data: { unreadCount: number }
}

export function useUnreadMessageCount() {
  const { data } = useQuery<UnreadCountResponse>({
    queryKey: ['me', 'messages', 'unread-count'],
    queryFn: () =>
      origin_point_engine_api({ url: '/me/messages/unread-count', method: 'GET' }),
    refetchInterval: 60_000, // 首期轮询：每分钟刷新一次
    staleTime: 30_000,
  })
  return data?.data?.unreadCount ?? 0
}
